import { CommonModule } from '@angular/common';
import { NgTemplateOutlet } from '@angular/common';
import { Component, ElementRef, ViewChild, input, output } from '@angular/core';
import { Validators } from '@angular/forms';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';

import { SearchFieldComponent } from '@camelot/form-input';
import { InputTextBox } from '@camelot/form-model';
import { FontIconComponent } from '@camelot/icons';
import {
  ContactInformationComponent,
  EmptyComponent,
  ListContainerComponent,
  ListElementComponent,
  ListTagComponent,
  ListTitleComponent,
} from '@camelot/ui';
import { LocalStorage } from '@camelot/utils';

@Component({
  selector: 'cam-search-history-displayer',
  templateUrl: './search-history-displayer.component.html',
  styleUrls: ['./search-history-displayer.component.scss'],
  imports: [
    CommonModule,
    MatMenuModule,
    ContactInformationComponent,
    EmptyComponent,
    ListContainerComponent,
    ListElementComponent,
    ListTitleComponent,
    ListTagComponent,
    FontIconComponent,
    SearchFieldComponent,
    NgTemplateOutlet,
  ],
})
export class SearchHistoryDisplayerComponent {
  searchHistory = input<{
    type: string;
  }>();

  placeholder = input('');

  isDropDown = input(false);

  valueCompleted = output<string>();

  @ViewChild('searchField', { read: ElementRef })
  searchField: ElementRef | null = null;
  @ViewChild('searchField', { read: MatMenuTrigger })
  searchTrigger: MatMenuTrigger | null = null;

  get searchFieldWidth() {
    return this.searchField?.nativeElement.offsetWidth;
  }
  get listRecentSearches() {
    const searchHistory = this.searchHistory();
    if (searchHistory?.type) {
      const storedSearches: { research: string }[] = this._getFromLocalStorage(searchHistory.type);
      const searches: string[] = storedSearches.map(obj => obj.research);
      return searches;
    }
    return null;
  }

  public input = new InputTextBox({
    validators: [Validators.minLength(3)],
  });

  public searchCompleted(search: string) {
    if (this.searchHistory()?.type) {
      this._saveInLocalStorage(search);
    }
    this.input.value = '';
    this.searchTrigger?.closeMenu();
    this.valueCompleted.emit(search);
    return;
  }

  private _getFromLocalStorage(type: string) {
    return JSON.parse(LocalStorage.get('search-' + type) || '[]');
  }

  private _saveInLocalStorage(searchValue: string) {
    const searchHistory = this.searchHistory();
    if (searchHistory?.type) {
      let storedSearches: { research: string; storageTime: Date }[] = this._getFromLocalStorage(searchHistory.type);
      const search = storedSearches.find(s => s.research === searchValue);
      if (search) {
        search.storageTime = new Date();
      } else {
        storedSearches.push({
          research: searchValue,
          storageTime: new Date(),
        });
      }
      this.orderAndSelect(storedSearches);
      LocalStorage.set('search-' + searchHistory.type || '', JSON.stringify(storedSearches.slice(0, 5)));
    }
  }

  private orderAndSelect(items: { storageTime: Date }[]) {
    items.sort((a, b) => {
      const dateA = new Date(a.storageTime);
      const dateB = new Date(b.storageTime);
      return dateB.getTime() - dateA.getTime();
    });
  }
}
